import { SelectColor } from 'components/colors/component'
import * as React from 'react'
import { Input, Label } from 'reactstrap'
import { getConfiguration } from '../../utils'

interface AppearanceSettingsProps {
  data: any
  name?: string
  onChange: (field: string, value: any) => void
}

export class AppearanceSettings extends React.Component<AppearanceSettingsProps> {
  public render() {
    return (
      <div>
        <div className="widget-settings-section">
          <h4>Card Appearance</h4>
          
          <div className="setting-item">
            <Label>Card Size</Label>
            <Input
              type="select"
              value={getConfiguration(this.props.data, 'survey_results_card_size', 'large')}
              onChange={(e) => this.props.onChange('survey_results_card_size', e.target.value)}
            >
              <option value="small">Small</option>
              <option value="large">Large</option>
            </Input>
          </div>

          <div className="setting-item">
            <Label>Border Color</Label>
            <SelectColor
              className="secondary"
              selectColor={(color: string) => this.props.onChange('survey_results_border_color', color)}
              color={getConfiguration(this.props.data, 'survey_results_border_color', '#dee2e6')}
            />
          </div>

          <div className="setting-item">
            <Label>Highlight Color</Label>
            <SelectColor
              className="primary"
              selectColor={(color: string) => this.props.onChange('survey_results_highlight_color', color)}
              color={getConfiguration(this.props.data, 'survey_results_highlight_color', '#7FAE1B')}
            />
            <small className="form-text text-muted">
              Used for progress bars, top percentage results, and accent borders
            </small>
          </div>
        </div>

        <div className="widget-settings-section">
          <h4>Color Scheme</h4>
          
          <div className="color-preview-grid">
            <div className="color-preview-item">
              <div 
                className="color-preview-box" 
                style={{ backgroundColor: getConfiguration(this.props.data, 'survey_results_highlight_color', '#7FAE1B') }}
              ></div>
              <small>Highlight Color</small>
            </div>
            <div className="color-preview-item">
              <div 
                className="color-preview-box" 
                style={{ backgroundColor: getConfiguration(this.props.data, 'survey_results_border_color', '#dee2e6') }}
              ></div>
              <small>Border Color</small>
            </div>
          </div>
        </div>

        <div className="widget-settings-section">
          <h4>Layout Preview</h4>
          <div className="layout-preview">
            <div 
              className="preview-card"
              style={{ 
                border: `1px solid ${getConfiguration(this.props.data, 'survey_results_border_color', '#dee2e6')}`,
                borderRadius: '8px',
                padding: '1rem',
                marginBottom: '0.5rem'
              }}
            >
              <div>Sample Survey Option</div>
              <div 
                className="preview-progress-bar"
                style={{ 
                  width: '100%',
                  height: '8px',
                  backgroundColor: '#e9ecef',
                  borderRadius: '4px',
                  marginTop: '0.5rem',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                <div 
                  style={{ 
                    width: '65%',
                    height: '100%',
                    backgroundColor: getConfiguration(this.props.data, 'survey_results_highlight_color', '#7FAE1B'),
                    borderRadius: '4px'
                  }}
                ></div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem', fontSize: '0.9rem' }}>
                <span style={{ color: getConfiguration(this.props.data, 'survey_results_highlight_color', '#7FAE1B'), fontWeight: 600 }}>
                  65.0%
                </span>
                <span style={{ color: '#6c757d' }}>132 votes</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}